export default {
  title: 'Logs do sistema',
  name: 'Nome',
  origin: 'Origem',
  level: 'Level',
  affectedEntities: 'Entidades afetadas',
  user: 'Usuário',
  time: 'Tempo',
  date: 'Data',
  cardViewSoon: 'Visão de cards (em breve)'
}
